
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/frettir/[slug]",
      function () {
        return require("private-next-pages/frettir/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/frettir/[slug]"])
      });
    }
  